import React from 'react';
import { CSSObject } from 'styled-components';
import { DivisorStyled } from './divisor.styled';
import { Variant, VariantEnum } from './types';

interface DivisorProps {
  variant?: Variant;
  mt?: number;
  sx?: CSSObject;
}

export const Divisor = (props: DivisorProps) => {
  return <DivisorStyled {...props} />;
};

Divisor.defaultProps = {
  variant: VariantEnum.horizontal,
};
